import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { number, arrayOf, bool, func, shape, string, oneOfType } from 'prop-types';
import ProductCarousel from '../../ProductCarousel';
import HighlightTitle from '../highlight-title';
import { ShowcaseContent } from '../showcase.styles';

const BetterOffer = _ref => {
  let {
    title,
    titleAs,
    titleSize,
    data,
    highlight,
    slidesPerViewBetterOffer,
    showSponsoredSubTitle,
    showButton,
    buttonProps
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["title", "titleAs", "titleSize", "data", "highlight", "slidesPerViewBetterOffer", "showDiscount", "showDiscountOnlyCashInfo", "showSponsoredSubTitle", "showButton", "buttonProps"]);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HighlightTitle, {
    title: title,
    titleAs: titleAs,
    titleSize: titleSize,
    highlightType: !!highlight,
    showSponsoredSubTitle: showSponsoredSubTitle,
    betterOffer: true
  }), /*#__PURE__*/React.createElement(ShowcaseContent, null, /*#__PURE__*/React.createElement(ProductCarousel, _extends({
    products: data,
    slidesPerView: slidesPerViewBetterOffer,
    enableHover: !highlight,
    showDiscountOnlyCashInfo: false,
    showDiscount: false,
    fullHeight: false,
    exhibition: "betteroffer",
    gutter: 24,
    displayMode: "list",
    showRating: false,
    showOfferTimer: true,
    showPartialNextSlide: true,
    cardType: "horizontal",
    show: true,
    showBorder: true,
    showButton: showButton,
    buttonProps: buttonProps,
    hideOriginalPrice: true
  }, props))));
};

BetterOffer.defaultProps = {
  slidesPerViewBetterOffer: 2,
  showButton: false,
  buttonProps: {}
};
process.env.NODE_ENV !== "production" ? BetterOffer.propTypes = {
  displayMode: string,
  data: arrayOf(shape),
  highlight: shape({}),
  title: string,
  titleAs: string,
  titleSize: oneOfType([string, number]),
  imageAltPrefix: string,
  productTitleAs: string,
  showFullListBtn: bool,
  showMoreBtn: bool,
  onClickLoadMore: func,
  showInCashInfo: bool,
  showPartialNextSlide: bool,
  auto: bool,
  slidesPerView: number,
  interval: number,
  transitionDuration: number,
  gutter: number,
  imgLazyLoading: bool,
  imageWidth: number,
  imageHeight: number,
  showControls: bool,
  showArrowControls: bool,
  showRating: bool,
  showDiscountOnlyCashInfo: bool,
  showDiscount: bool,
  showSponsoredSubTitle: bool,
  slidesPerViewBetterOffer: number,
  showButton: bool,
  buttonProps: shape({}),
  hideOriginalPrice: bool
} : void 0;
export default BetterOffer;